import { render } from "./Beacon.vue?vue&type=template&id=4ed3046d"
import script from "./Beacon.vue?vue&type=script&lang=ts"
export * from "./Beacon.vue?vue&type=script&lang=ts"
script.render = render

export default script